
const STORAGE_KEY = 'userCountryCode';
const ONE_DAY = 24 * 60 * 60 * 1000;
const API_URL = 'https://sefi-ip-api-service-1015350951650.europe-west3.run.app/get-user-ip';

const euCountries = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU',
  'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
];

function getCachedCountry() {

  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const obj = JSON.parse(raw);
    if (Date.now() - obj.timestamp < ONE_DAY) {
      return obj.code;
    } else {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
  } catch (e) {
    return null;
  }
}

function setCachedCountry(code) {

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ code, timestamp: Date.now() }));
  } catch (e) { }
}

function checkAndDisplayElements(countryCode) {

  const elements = document.querySelectorAll('.custom-taxes-info-item');

  elements.forEach(element => {
    if (element.getAttribute('data-show') === 'true') {
      const customCountries = (element.getAttribute('data-custom-countries') || '')
        .split(',')
        .map((code) => code.trim().toUpperCase())
        .filter((code) => code.length > 0);

      const allowedCountries = [...euCountries, ...customCountries];


      element.style.display = allowedCountries.includes(countryCode) ? 'block' : 'none';
    }



  });
}


async function initCountryDisplayManager() {
  const cachedCountry = getCachedCountry();

  if (cachedCountry) {
    console.log('Using cached country code:', cachedCountry);
    checkAndDisplayElements(cachedCountry);
    return;
  }

  try {
    const response = await fetch(API_URL);
    const data = await response.json();
    const countryCode = data.location_info.countryCode;

    console.log('Fetched country code:', countryCode);
    setCachedCountry(countryCode);
    checkAndDisplayElements(countryCode);
  } catch (error) {
    console.error('Error fetching IP-info:', error);

  }
}

document.addEventListener('DOMContentLoaded', initCountryDisplayManager);